import Grid from "@mui/material/Grid";
import DSFRListContext from "components/DSFRListContext";
import PropTypes from "prop-types";
import React, { useMemo } from "react";

const DSFRSpecificList = (props) => {
  let { cards = [] } = props;

  if (cards && !Array.isArray(cards)) {
    cards = [cards];
  }

  let columns = 12;
  let lg = 3;
  const size = React.Children.count(cards);
  if (size <= 5) {
    columns = size * lg;
  } else if (size === 6) {
    lg = 4;
  }

  const DSFRListContextValue = useMemo(
    () => ({ xs: columns, sm: size === 1 ? columns : columns / 2, lg }),
    [columns, lg, size],
  );

  if (!cards || cards.length === 0) {
    return null;
  }

  return (
    <DSFRListContext.Provider value={DSFRListContextValue}>
      <Grid
        container
        columns={columns}
        spacing={{ xs: 3, md: 1 }}
        sx={{ "&&": { mt: 0 } }}
        component="ul"
        className="fr-raw-list"
      >
        {cards}
      </Grid>
    </DSFRListContext.Provider>
  );
};

DSFRSpecificList.propTypes = {
  cards: PropTypes.arrayOf(PropTypes.shape()),
};

export default DSFRSpecificList;
